import React from "react";
import MovieListing from "../MovieListing/MovieListing";
import "./Home.css";

const Home = () => {
  return (
    <div>
      <MovieListing />
    </div>
  );
};

export default Home;
